import { render, staticRenderFns } from "./PdvProdutos.vue?vue&type=template&id=7e1d9e98&scoped=true&"
import script from "./PdvProdutos.vue?vue&type=script&lang=js&"
export * from "./PdvProdutos.vue?vue&type=script&lang=js&"
import style0 from "./PdvProdutos.vue?vue&type=style&index=0&id=7e1d9e98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1d9e98",
  null
  
)

export default component.exports